import SurveyControllerContainer from './SurveyControllerContainer'
import { withRouter } from 'react-router'

export default withRouter(SurveyControllerContainer)



// WEBPACK FOOTER //
// ./src/modules/Controllers/Survey/SurveyControllerContainer/index.js